import React, {memo} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

type Props = {
  name: string | React.ReactNode; // Name of the resource that going to be save
  onSave: () => void;
  onCancel: () => void;
  open?: boolean;
};

const DialogConfirmSave = memo(
  ({name, onSave, onCancel, open = true}: Props) => {
    return (
      <Dialog maxWidth='sm' fullWidth open={open}>
        <DialogTitle>
          <Typography
            sx={{width: '100% !important'}}
            className='flex justify-center ml-0'>
            Confirmation
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant='body1'
            className='text-center text-white'
            marginBottom={1}>
            {name}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button color='primary' variant='contained' onClick={onSave}>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

DialogConfirmSave.displayName = 'DialogConfirmSave';

export default DialogConfirmSave;
